import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c4e00ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "tags-view-container",
  class: "tags-view-container"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 刷新页面 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 关闭当前 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 关闭其他 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 关闭左侧 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 关闭右侧 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 全部关闭 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_scroll_pane = _resolveComponent("scroll-pane")!
  const _component_RefreshRight = _resolveComponent("RefreshRight")!
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_Back = _resolveComponent("Back")!
  const _component_Right = _resolveComponent("Right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_scroll_pane, {
      ref: "scrollPane",
      class: "tags-view-wrapper",
      onScroll: _ctx.handleScroll
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitedViews, (tag) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            ref_for: true,
            ref: "tag",
            key: tag.path,
            to: { path: tag.path, query: tag.query },
            custom: "",
            onMouseup: _withModifiers(($event: any) => (!_ctx.isAffix(tag)?_ctx.closeSelectedTag(tag):''), ["middle"]),
            onContextmenu: _withModifiers(($event: any) => (_ctx.openMenu(tag,$event)), ["prevent"])
          }, {
            default: _withCtx(({ navigate }) => [
              _createElementVNode("div", {
                class: _normalizeClass(["tags-view-item", _ctx.isActive(tag)?'active':'']),
                style: _normalizeStyle(_ctx.activeStyle(tag)),
                onClick: ($event: any) => (_ctx.handleTagClick(tag, navigate))
              }, [
                _createTextVNode(_toDisplayString(tag.title) + " ", 1),
                _createElementVNode("span", null, [
                  (!_ctx.isAffix(tag))
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        class: "close-icon",
                        onClick: _withModifiers(($event: any) => (_ctx.closeSelectedTag(tag)), ["stop","prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Close)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ], 14, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["to", "onMouseup", "onContextmenu"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onScroll"]),
    _withDirectives(_createElementVNode("ul", {
      style: _normalizeStyle({left:_ctx.left+'px',top:_ctx.top+'px'}),
      class: "contextmenu"
    }, [
      _createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshSelectedTag(_ctx.selectedTag)))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_RefreshRight)
          ]),
          _: 1
        }),
        _hoisted_3
      ]),
      (!_ctx.isAffix(_ctx.selectedTag))
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeSelectedTag(_ctx.selectedTag)))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            }),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeOthersTags && _ctx.closeOthersTags(...args)))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_CircleClose)
          ]),
          _: 1
        }),
        _hoisted_5
      ]),
      (!_ctx.isFirstView())
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeLeftTags && _ctx.closeLeftTags(...args)))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Back)
              ]),
              _: 1
            }),
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLastView())
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeRightTags && _ctx.closeRightTags(...args)))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Right)
              ]),
              _: 1
            }),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeAllTags(_ctx.selectedTag)))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_CircleClose)
          ]),
          _: 1
        }),
        _hoisted_8
      ])
    ], 4), [
      [_vShow, _ctx.visible]
    ])
  ]))
}